// extracted by mini-css-extract-plugin
module.exports = {"spinnerBase":"Spinner_spinnerBase__JfRb0","rotation":"Spinner_rotation__tYtRP","light":"Spinner_light__4jrPF","signature":"Spinner_signature__BxhxS"};